import { HttpClient, HttpErrorResponse, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { environment } from 'environments/environment';
import { Project, Offer } from '@app/shared';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';

export enum FileQueueStatus {
  Pending,
  Success,
  Error,
  Progress
}

export class FileQueueObject {
  public file: any;
  public status: FileQueueStatus = FileQueueStatus.Pending;
  public progress: number = 0;
  public request: Subscription = null;
  public response: HttpResponse<any> | HttpErrorResponse = null;
  private logger:NGXLogger

  constructor(file: any) {
    this.file = file;
  }

  // actions
  public upload = () => { /* set in service */ };
  public cancel = () => { /* set in service */ };
  public remove = () => { /* set in service */ };

  // statuses
  public isPending = () => this.status === FileQueueStatus.Pending;
  public isSuccess = () => this.status === FileQueueStatus.Success;
  public isError = () => this.status === FileQueueStatus.Error;
  public inProgress = () => this.status === FileQueueStatus.Progress;
  public isUploadable = () => this.status === FileQueueStatus.Pending || this.status === FileQueueStatus.Error;

}

// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class FileUploaderService {

  public url: string = `${environment.uploadURL}campaign/`;

  private _queue: BehaviorSubject<FileQueueObject[]>;
  private _files: FileQueueObject[] = [];
  // private logger:NGXLogger;

  constructor(private http: HttpClient, private logger:NGXLogger) {
    this._queue = <BehaviorSubject<FileQueueObject[]>>new BehaviorSubject(this._files);
  }

  // the queue
  public get queue() {
    return this._queue.asObservable();
  }

  // public events
  public onCompleteItem(queueObj: FileQueueObject, response: any, token:string = ''): any {
    return { queueObj, response, token };
  }

  // public functions
  public addToQueue(data: any) {
    // add file to the queue
    for (let file of data) {
      this._addToQueue(file)
    }
    //data.map(file => this._addToQueue(file))
  //  _.each(data, (file: any) => this._addToQueue(file));
  }

  public clearQueue() {
    // clear the queue
    this._files = [];
    this._queue.next(this._files);
  }

  public uploadAll(project:Project) {

    let tmpURL = `${environment.uploadURL}campaign/${project.uuid}/uploadPreAuth`;

    if(this._files[0].file.type === "text/csv") {
      tmpURL += `?fileExt=csv`;
    } else if(this._files[0].file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      tmpURL += `?fileExt=xlsx`;
    }
    
    // upload all except already successfull or in progress

    this.getReqURL(tmpURL).subscribe(
      (event: any) => {
        let result = event.data[0];
        this.url = result.url;

        this._files.map((queueObj: FileQueueObject) => {
          if (queueObj.isUploadable()) {
            this._upload(queueObj);
          }
        });

        //this.logger.debug(event,'success')
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          this.logger.debug(err,'ERROR')
        } else {
          this.logger.debug(err,'ERROR')
        }
      }
    );
  }

  public uploadAllVendor(offer:Offer) {
    const tmpURL = `${environment.uploadURL}offer/${offer.uuid}/uploadPreAuth`;
    // upload all except already successfull or in progress

    this.getReqURL(tmpURL).subscribe(
      (event: any) => {
        let result = event.data[0];
        this.url = result.url;

        this._files.map((queueObj: FileQueueObject) => {
          if (queueObj.isUploadable()) {
            this._upload(queueObj,result.token);
          }
        });

        //this.logger.debug(event,'success')
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          this.logger.debug(err,'ERROR')
        } else {
          this.logger.debug(err,'ERROR')
        }
      }
    );
  }


  // private functions
  private _addToQueue(file: any) {
    const queueObj = new FileQueueObject(file);

    // set the individual object events
    queueObj.upload = () => this._upload(queueObj);
    queueObj.remove = () => this._removeFromQueue(queueObj);
    queueObj.cancel = () => this._cancel(queueObj);

    // push to the queue
    this._files.push(queueObj);
    this._queue.next(this._files);
  }

  private _removeFromQueue(queueObj: FileQueueObject) {
    //_.remove(this._files, queueObj);

    for(let i = 0; i< this._files.length; i++){
      if(this._files[i] === queueObj){
        this._files.splice(i, 1);
        break;
      }
    }

  }

  private getReqURL(url:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<String>(encodeURI(url),{
       //params : httpParams
       headers: headers
    })
  }

  private _addMediaToOffer(offer:Offer, token:string, queueObj: FileQueueObject){

  }

  private _upload(queueObj: FileQueueObject,token:string="") {

    this.logger.debug(this.url,token);

    // create form data for file
    const form = new FormData();
    form.append('file', queueObj.file, queueObj.file.name);

    let headers = new HttpHeaders({
                   "Content-Type": undefined,
                  })

    // upload file and report progress
    // const req = new HttpRequest('PUT', this.url, form, {
    //   reportProgress: true,
    //   headers: headers,
    //   //withCredentials: false,
    // });


    const req = new XMLHttpRequest();
                req.open('PUT', this.url);
                req.setRequestHeader('Content-Type', undefined);
                req.onreadystatechange = () => {
                  this.logger.debug(req);
                    if (req.readyState === 4) {
                        if (req.status === 200) {
                            this._uploadComplete(queueObj, null, token);
                            this.logger.debug('success');
                        } else {
                            this._uploadFailed(queueObj, null);
                            this.logger.debug('error');
                        }
                    }
                };
        req.send(queueObj.file);

    // const req = new XMLHttpRequest();
    // req.open('PUT', this.url);
    //  .set('Content-Type', undefined)
    //  .send(theFile)     // <--------------------------- THIS LINE instead of .attach()
    //  .on('progress', () => {
    //                  if (req.readyState === 4) {
    //                      if (req.status === 200) {
    //                          console.debug('success');
    //                      } else {
    //                          console.error('error');
    //                      }
    //                  }
    //              })
    //  .end(success, failure)


    // upload file and report progress
    // queueObj.request = this.http.request(req).subscribe(
    //   (event: any) => {
    //     if (event.type === HttpEventType.UploadProgress) {
    //       this._uploadProgress(queueObj, event);
    //     } else if (event instanceof HttpResponse) {
    //       this._uploadComplete(queueObj, event);
    //     }
    //   },
    //   (err: HttpErrorResponse) => {
    //     if (err.error instanceof Error) {
    //       // A client-side or network error occurred. Handle it accordingly.
    //       this._uploadFailed(queueObj, err);
    //     } else {
    //       // The backend returned an unsuccessful response code.
    //       this._uploadFailed(queueObj, err);
    //     }
    //   }
    // );

    return queueObj;
  }

  private _cancel(queueObj: FileQueueObject) {
    // update the FileQueueObject as cancelled
    queueObj.request.unsubscribe();
    queueObj.progress = 0;
    queueObj.status = FileQueueStatus.Pending;
    this._queue.next(this._files);
  }

  private _uploadProgress(queueObj: FileQueueObject, event: any) {
    // update the FileQueueObject with the current progress
    const progress = Math.round(100 * event.loaded / event.total);
    queueObj.progress = progress;
    queueObj.status = FileQueueStatus.Progress;
    this._queue.next(this._files);
  }

  private _uploadComplete(queueObj: FileQueueObject, response: HttpResponse<any>, token:string) {
    // update the FileQueueObject as completed
    queueObj.progress = 100;
    queueObj.status = FileQueueStatus.Success;
    queueObj.response = response;
    this._queue.next(this._files);

    if(response)
      this.onCompleteItem(queueObj, response.body, token);
    else
      this.onCompleteItem(queueObj, null, token);
  }

  private _uploadFailed(queueObj: FileQueueObject, response: HttpErrorResponse) {
    // update the FileQueueObject as errored
    queueObj.progress = 0;
    queueObj.status = FileQueueStatus.Error;
    queueObj.response = response;
    this._queue.next(this._files);
  }

  downloadFile(uri:string): Observable<Blob> {
    return this.http.get(uri, { responseType: 'blob' });
  }
  
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/file-uploader.service.ts